// extracted by mini-css-extract-plugin
export default {"root":"QuizProgressBarV2_root-FN2","segment":"QuizProgressBarV2_segment-gnt","filled":"QuizProgressBarV2_filled-eNh"};